import React from 'react';
import { Link } from 'react-router-dom';
import FilterItemContainer from './itemContainer';
import FilterItemHeading from './itemHeading';
import FilterSelected from './selected';
import FilterIcon from 'images/filter-icon.png';
import { currentQueryParams, pathForQueryParams } from './helpers';
import { SecondarySmall } from 'scy/text';
import { right } from 'scy/utils.mod.scss';

export default function CurrentFilters({ facets, location }) {
  const currentParams = currentQueryParams(location);
  const activeFacets = facets
    .filter(({ facet }) => typeof currentParams[facet] !== 'undefined')
    .map(({ facet }) => ({ facet, value: currentParams[facet] }));

  const removeAllQueryParams = activeFacets.reduce(
    (params, { facet }) => ({ ...params, skip: null, [facet]: null }),
    {}
  );
  const removeAllPath = pathForQueryParams(location, removeAllQueryParams);

  return (
    <FilterItemContainer icon={FilterIcon}>
      <FilterItemHeading title="Filtering By">
        {!!activeFacets.length && (
          <Link
            to={removeAllPath}
            replace={!currentParams.skip}
            className={right}
          >
            <SecondarySmall tag="span">Clear</SecondarySmall>
          </Link>
        )}
      </FilterItemHeading>

      {activeFacets.map(({ facet, value }) => {
        const removePath = pathForQueryParams(location, { [facet]: null });
        return (
          <FilterSelected
            key={`${facet}:${value}`}
            label={value}
            renderRemove={() => (
              <Link to={removePath} replace={!currentParams.skip}>
                ×
              </Link>
            )}
          />
        );
      })}
    </FilterItemContainer>
  );
}
